import { Sun, Moon } from 'lucide-react';
import { useTheme } from '@/modules/shared/hooks/useTheme';

/**
 * ThemeModeToggle — 深浅模式切换按钮
 *
 * 显示太阳/月亮图标，点击切换主题
 */
export default function ThemeModeToggle() {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      onClick={toggleTheme}
      className="w-8 h-8 rounded-full flex items-center justify-center
                 bg-[var(--y-surface-secondary)]
                 hover:bg-[var(--y-surface-tertiary)]
                 transition-all duration-200
                 focus:outline-none focus:ring-2 focus:ring-[var(--y-accent)]/30"
      aria-label={isDark ? '切换到浅色模式' : '切换到深色模式'}
    >
      {isDark ? (
        <Sun className="w-4 h-4 text-[var(--y-text-secondary)]" />
      ) : (
        <Moon className="w-4 h-4 text-[var(--y-text-secondary)]" />
      )}
    </button>
  );
}
